import { render, staticRenderFns } from "./Battlefield.vue?vue&type=template&id=a5709448&"
import script from "./Battlefield.vue?vue&type=script&lang=ts&"
export * from "./Battlefield.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports